<template>
  <div class="takeaway-wrapper">
    <div v-if="clientPlatform == 'Web'" class="takeaway-desktop">
      <take-away-page-body :modulePropsData="modulePropsData" />
    </div>
    <div v-if="clientPlatform !== 'Web'" class="takeaway-pwa">
      <generic-modal
        :width="orderSelectionModal.width"
        :modalClass="orderSelectionModal.modalClass"
        :height="orderSelectionModal.height"
      >
        <template v-slot:header>
          <take-away-page-header />
        </template>
        <template v-slot:body>
          <take-away-page-body :modulePropsData="modulePropsData" />
        </template>
        <template v-slot:footer>
          <div></div>
        </template>
      </generic-modal>
    </div>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import TakeAwayPageHeader from "./TakeAwayPageHeader.vue";
import TakeAwayPageBody from "./TakeAwayPageBody.vue";
import { clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import Utility from "../helpers/utility";

export default {
  name: "TakeAwayPage",
  components: {
    GenericModal,
    TakeAwayPageHeader,
    TakeAwayPageBody,
  },
  props: ["modulePropsData"],
  data() {
    return {
      clientPlatform,
      orderSelectionModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup cust-modal-wrap take-away-container",
        currentSlide: 0,
      },
    };
  },
  mounted() {
    if (LocalStorageFunc.getIsAddEditAddressFlow()) {
      this.$store.commit(
        keyMapsMutation.TOGGLE_ADD_EDIT_ADDRESS_LOCATION_SCREEN
      );
    }
      if (this.isChangeTriggeredFromTakeawayDinein) {
        let item = LocalStorageFunc.getSelectedChangedLocationForTwyDinein();
        let query = {
          place_id: item.placeId,
        };
        this.$store.dispatch(keyMapsAction.GEO_CODE_API, query).then((res) => {
          if (res.data.status === "SUCCESS") {
            if (res.data?.results[0]) {
              let pos = res.data.results[0].geometry.location;
              this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
                latitude: pos.lat,
                longitude: pos.lng,
                orderType: this.selectedOrderType,
              });

              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
                false
              );
              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
                false
              );

              LocalStorageFunc.updateLastLocationOnConfirmedLocation();
            }
          }
        });
      } else if (
        this.currentOrderType !== "D" &&
        this.selectedStoreData &&
        Object.keys(this.selectedStoreData).length
      ) {
        this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
          latitude: this.selectedStoreData.latitude,
          longitude: this.selectedStoreData.longitude,
          orderType: this.selectedOrderType,
        });

        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
          false
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
          false
        );

        LocalStorageFunc.updateLastLocationOnConfirmedLocation();
      } else if (this.currentOrderType === "D") {
        let lat = 0;
        let lng = 0;
        if (
          this.selectedSavedAddress &&
          Object.keys(this.selectedSavedAddress).length
        ) {
          lat = this.selectedSavedAddress.latitude;
          lng = this.selectedSavedAddress.longitude;
        } else if (
          this.lastLocNewCoords &&
          Object.keys(this.lastLocNewCoords).length
        ) {
          lat = this.lastLocNewCoords.latitude;
          lng = this.lastLocNewCoords.longitude;
        } else if (
          this.noDeliveryZoneData &&
          Object.keys(this.noDeliveryZoneData).length
        ) {
          lat = this.noDeliveryZoneData.location.latitude;
          lng = this.noDeliveryZoneData.location.longitude;
        }
        if (lat !== 0) {
          this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
            latitude: lat,
            longitude: lng,
            orderType: this.selectedOrderType,
          });

          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
            false
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
            false
          );

          LocalStorageFunc.updateLastLocationOnConfirmedLocation();
        }
      }
  },
  methods: {},
  watch: {},
  computed: {
    isChangeTriggeredFromTakeawayDinein() {
      let queryParams = Utility.getQueryFromUrl();
      return queryParams["changeTriggerFromDineinTwy"] == "true" || false;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    selectedOrderType() {
      return (
        LocalStorageFunc.getSelectedDeliveryType() ||
        this.$store.state.User.currentOrderType
      );
    },
    noDeliveryZoneData() {
      return this.$store.state.Location?.noDeliveryZoneData?.displayText
        ? this.$store.state.Location?.noDeliveryZoneData
        : LocalStorageFunc.getNoDeliveryZoneData();
    },
    selectedStoreData() {
      return LocalStorageFunc.getSelectedStore();
    },
    selectedSavedAddress() {
      return this.$store.state.User.selectedSavedAddress;
    },
    lastLocNewCoords() {
      return (
        LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
          ?.location || {}
      );
    },
  },
};
</script>

<style></style>
